export default class LoadingAnimation {
  public static EVENT_TYPE: string = 'loadingAnimation';

  public static async perform(callback: Function) {
    this.show();
    await callback();
    this.hide();
  }

  public static hide() {
    this.sendEvent(false);
  }

  public static show() {
    this.sendEvent(true);
  }

  private static sendEvent(animationVisibility: boolean) {
    const event = new CustomEvent(this.EVENT_TYPE, { detail: animationVisibility });
    window.dispatchEvent(event);
  }
}
